/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {DB_Organization} from "@app/ir-q-app-common/types/care-center/organization";

export type OrganizationMap = { [_id: string]: DB_Organization };

export type OrganizationsContextType = {
    organizations: OrganizationMap
    saveOrganizations: (organizations: DB_Organization[]) => void
    deleteOrganizations: (orgId: string) => void
}

export const OrganizationsContext = React.createContext<OrganizationsContextType>({
    organizations: {},
    saveOrganizations: (orgs) => {},
    deleteOrganizations: (orgId) => {}
});